import { TEALIUM_INTERACTION_ID } from '@client/analytics/types/types';
import { ANALYTICS_ATTRIBUTES, BaseBuilder } from '@client/analytics/utils/builders/BaseBuilder';

// DSA component tracking event IDs (see _docs/DSA component tracking spec).
const LOGOUT_INTERACTION_ID = '915';

export class AccountInteractionAnalyticsBuilder extends BaseBuilder<any> {
  protected attributes = [
    ANALYTICS_ATTRIBUTES.category,
    ANALYTICS_ATTRIBUTES.subcategory,
    ANALYTICS_ATTRIBUTES.attribute1,
    ANALYTICS_ATTRIBUTES.attribute3,
    ANALYTICS_ATTRIBUTES.location,
  ];

  public build(): any {
    this.analyticsResultObject = {
      [ANALYTICS_ATTRIBUTES.category]: ['account'],
      [ANALYTICS_ATTRIBUTES.subcategory]: ['login'],
      [ANALYTICS_ATTRIBUTES.attribute1]: ['link'],
      [ANALYTICS_ATTRIBUTES.attribute3]: ['logout'],
      [ANALYTICS_ATTRIBUTES.location]: ['header'],
    };

    return {
      interaction: TEALIUM_INTERACTION_ID.genericEvent,
      interaction_id: LOGOUT_INTERACTION_ID,
      [ANALYTICS_ATTRIBUTES.component]: {
        ...super.build(),
      },
    };
  }
}
